module.exports = __webpack_public_path__ + "img/technologyOption.0eb886f5.jpeg";